<template>
	<v-autocomplete
		variant="outlined"
		:label="$gettext('Country')"
		:model-value="modelValue"
		:items="countries"
		item-title="countryName"
		item-value="id"
		v-bind="$attrs"
		@update:model-value="(emit) => $emit('update:model-value', emit)"
	/>
</template>
<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'CountrySelect',
	props: {
		modelValue: {
			type: Number,
			required: false,
			default: null
		}
	},

	emits: ['update:model-value',],

	data () {
		return {
			countries: []
		};
	},

	mounted () {
		this.getCountries();
	},

	methods: {
		/**
		 * get all available countries
		 */
		getCountries () {
			axios.get('/api/v0/countries?limit=250').then(({
				data
			}) => {
				this.countries = data;
			});
		}
	}
};
</script>
